<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Yatırım / Çekim İşlemleri
        </h3>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 250px">
            <input
              type="text"
              v-model="transaction"
              class="form-control float-right"
              placeholder="İşlem Ara"
            />

            <div class="input-group-append">
              <button type="button" @click="pagination" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <table class="table table-striped projects">
            <thead>
              <tr>
                <th>#</th>
                <th>Transaction ID</th>
                <th>Tarih</th>
                <th>Tutar</th>
                <th>Yatırım / Çekim</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in datas" :key="index">
                <td>{{ ++index + ((page-1) * count) }}</td>
                <td>{{ data.transaction }}</td>
                <td>{{ data.date | DateFormat }}</td>
                <td>{{ data.amount.toFixed(2) }} TL</td>
                <td>{{ data.type ? "Yatırım" : "Çekim" }}</td>
              </tr>
              <tr>
                <td v-if="datas.length == 0" colspan="5" class="text-center">
                  Kayıt Bulunamadı
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer">
        <pagination
          v-model="page"
          :records="rows"
          :per-page="count"
          @paginate="pagination"
        />
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["customer"],
  data() {
    return {
      datas: [],
      transaction: "",
      overlay: false,
      page: 1,
      count: 10,
      rows: 100,
    };
  },

  methods: {
    getDatas(type = false) {
      this.overlay = true;
      this.$http
        .post("Finance/ListFinance/", {
          code: this.customer.code,
          page: this.page - 1,
          transaction: this.transaction,
          rowNumber: type,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else this.datas = response.data;

          this.overlay = false;
        });
    },
    pagination(value) {

     
      this.getDatas();
      this.getDatas(true);
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },

  created() {
    this.getDatas();
    this.getDatas(true);
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerFinance.vue